// extracted by mini-css-extract-plugin
export default {"Backdrop":"Backdrop__Backdrop__tGpzj"};